import type { CoverThumbnail } from '@tanko/shared'

/** 產生封面縮圖（本地與雲端共用），回傳縮圖本身與尺寸；寬度另供升級判斷是否過小。 */
export function createThumbnail(blob: Blob, signal?: AbortSignal): Promise<CoverThumbnail> {
  if (signal?.aborted) return Promise.reject(new DOMException('已取消縮圖', 'AbortError'))
  return new Promise<CoverThumbnail>((resolve, reject) => {
    const worker = new Worker(new URL('../workers/thumbnail.worker.ts', import.meta.url), { type: 'module' })
    const cleanup = () => { clearTimeout(timeout); signal?.removeEventListener('abort', abort); worker.terminate() }
    const abort = () => { cleanup(); reject(new DOMException('已取消縮圖', 'AbortError')) }
    const timeout = setTimeout(() => { cleanup(); reject(new Error('封面處理逾時，請重試')) }, 30000)
    signal?.addEventListener('abort', abort, { once: true })
    worker.onmessage = (event: MessageEvent<{ blob?: Blob; width?: number; height?: number; error?: string }>) => {
      cleanup()
      if (event.data.blob && event.data.width && event.data.height) resolve({ blob: event.data.blob, width: event.data.width, height: event.data.height })
      else reject(new Error(event.data.error ?? '無法產生縮圖'))
    }
    worker.onerror = () => { cleanup(); reject(new Error('縮圖 Worker 無法啟動')) }
    worker.postMessage(blob)
  })
}
